/**
 * B2B pricing: discount on route price excluding toll, then add toll, then 5% GST.
 * Toll is never discounted. Mirrors dash-unload/frontend/src/utils/b2bPricing.js.
 */

export function getBaseFareExclToll(vehicleOption) {
  const toll = parseFloat(vehicleOption?.toll_price_applied) || 0;
  if (
    vehicleOption?.floored_subtotal_excl_toll != null &&
    vehicleOption.floored_subtotal_excl_toll !== ''
  ) {
    return parseFloat(vehicleOption.floored_subtotal_excl_toll) || 0;
  }
  const estimated = parseFloat(vehicleOption?.estimated_price) || 0;
  return Math.max(0, Math.round((estimated - toll) * 100) / 100);
}

/** @returns {{ baseExclToll, toll, discountAmount, discountedBase, subtotalBeforeGst, gstAmount, grandTotal, discountPercentage }} */
export function calculateB2bBookingPrice(vehicleOption, discountPercentage = 0) {
  const toll = parseFloat(vehicleOption?.toll_price_applied) || 0;
  const baseExclToll = getBaseFareExclToll(vehicleOption);
  const discPct = parseFloat(discountPercentage) || 0;
  const requestedDiscount = discPct > 0 ? Math.ceil((baseExclToll * discPct) / 100) : 0;
  let discountedBase = Math.ceil(baseExclToll - requestedDiscount);
  const floor = parseFloat(vehicleOption?.base_price) || 0;
  let cappedAtBase = false;
  if (floor > 0 && discountedBase < floor && baseExclToll >= floor) {
    discountedBase = Math.ceil(floor);
    cappedAtBase = true;
  }
  const fareCeil = Math.ceil(baseExclToll);
  if (discountedBase > fareCeil) discountedBase = fareCeil;
  const discountAmount = Math.max(0, fareCeil - discountedBase);
  const effectivePercent = discountAmount > 0
    ? (cappedAtBase
      ? Math.round(((baseExclToll - discountedBase) / baseExclToll) * 10000) / 100
      : discPct)
    : 0;
  const subtotalBeforeGst = Math.ceil(discountedBase + toll);
  const gstAmount = Math.ceil(subtotalBeforeGst * 0.05);
  const grandTotal = Math.ceil(subtotalBeforeGst + gstAmount);

  return {
    baseExclToll,
    toll,
    discountPercentage: effectivePercent,
    requestedDiscountPercentage: discPct,
    discountAmount,
    cappedAtBase,
    basePrice: floor,
    discountedBase,
    subtotalBeforeGst,
    gstAmount,
    grandTotal,
  };
}

export function formatInr(amount) {
  return `₹${Number(amount).toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
}
